import { useState, useEffect, useCallback } from "react";
import "../styles/Applicant.css";
import Swal from "sweetalert2";
import axios from "axios";
import moment from "moment";
import { DatePicker, message, Button, Select } from "antd";
import HrDropdown from "./HrDropdown";
import "../styles/Regform.css";
import { useParams } from 'react-router-dom';

import useAuth from "../hooks/useAuth";
import ButtonGroup from "antd/es/button/button-group";
import debounce from "lodash.debounce";
// import { Option } from "antd/es/mentions";

const URL = process.env.REACT_APP_API_URL;
function Registration({ closeModal, appliedPosition, jobPost,  jobPositionId, department,vertical }) {
  console.log('appliedPosition: ', appliedPosition);
  console.log('ID: ', jobPositionId);
  const { token, auth } = useAuth();

  const [positions, setPositions] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [stateSuggestions, setStateSuggestions] = useState([]);
  const { positionId } = useParams();  // Capture positionId from the URL

  const { Option } = Select;

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    totalExperience: "",
    relevantExperience: "",
    noticePeriod: "",
    qualification: "",
    contact: "",
    email: "",
    position: "",
    currentLocation: "",
    selectedCategory: "",
    image: "",
    resume: "",
    mgrName: "",
    mgrEmail: "",
    lwd: "",
    state: "",
    district: "",
    city: "",
    reference: "",
    source: "",
    jobId: "",
    postedAt: "",
    vertical: "",
    department: "",
    aniTests: [],
  });

  const [errors, setErrors] = useState({
    qualification: [],
    city: [],
    district: [],
  });

  const checkGrammar = async (field, text) => {
    if (!text.trim()) {
      setErrors((prev) => ({ ...prev, [field]: [] }));
      return;
    }

    try {
      const res = await axios.post(
        'https://api.languagetoolplus.com/v2/check',
        null,
        {
          params: {
            text,
            language: 'en-US',
          },
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        }
      );
      console.log('response', res);

      setErrors((prev) => ({ ...prev, [field]: res.data.matches }));
    } catch (err) {
      console.error(`Error checking ${field}:`, err);
    }
  };

  // Debounced checker
  const debouncedCheckGrammar = useCallback(
    debounce((field, value) => checkGrammar(field, value), 600),
    []
  );

  const [selectedHrName, setSelectedHrName] = useState("");
  const [selectedHrEmail, setSelectedHrEmail] = useState("");

  const handleSelectHr = (fullName, email) => {
    setSelectedHrName(fullName);
    setSelectedHrEmail(email);
  };

  useEffect(() => {
    // Fetch job data using positionId to prefill relevant fields
    if (positionId) {
      fetchJobDetails(positionId);
    }
  }, [positionId]);

  // Prefill when opened from Explore modal (props provided)
 useEffect(() => {
  if (appliedPosition || jobPost || jobPositionId) {
    setFormData((prevState) => ({
      ...prevState,
      position: appliedPosition || prevState.position,
      postedAt: jobPost || prevState.postedAt,
      jobId: jobPositionId || prevState.jobId,
      source: !auth.email ? "career" : prevState.source,
      department: department || prevState.department,
      vertical: vertical || prevState.vertical,

      }));
    // setIsExploreForm(isFromExplore);
  }
}, [appliedPosition, jobPost, jobPositionId, department, vertical]);

  const fetchJobDetails = async (positionId) => {
    try {
      const response = await axios.get(`${URL}/api/job/position/${positionId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const jobData = response.data;

      // Check if the job status is "REQ Approved"
      if (jobData.status === "REQ Approved") {
        setFormData((prevState) => ({
          ...prevState,
          position: jobData.positionId,
          qualification: jobData.requiredQualification,
        }));
      } else {
        message.warning("The selected job is not approved for registration.");
      }
    } catch (error) {
      console.error("Error fetching job details:", error);
    }
  };

  const handlePositionChange = (e) => {
    const selectedPosition = e.target.value;

    // Find the selected job in the positions array
    const selectedJob = positions.find(job => job.position === selectedPosition);
    console.log('selectedJob vertical: ', selectedJob.vertical);
    console.log('selectedJob department: ', selectedJob.department);

    // Retrieve the postedAt date
    const postedAt = selectedJob ? selectedJob.postedAt : null;
    const positionId = selectedJob ? selectedJob.positionId : null; // Get the positionId from the selected job
    // const jobid = selectedJob ? selectedJob.positionId: null; // Get the job ID from the selected job
    setFormData((prevState) => ({
      ...prevState,
      position: selectedPosition, // Update position
      postedAt: postedAt,
      jobId: positionId,         // Store postedAt in formData
      vertical: selectedJob.vertical,
      department: selectedJob.department
    }));
  };

  const statesList = [
    "Andhra Pradesh",
    "Arunachal Pradesh",
    "Assam",
    "Bihar",
    "Chhattisgarh",
    "Goa",
    "Gujarat",
    "Haryana",
    "Himachal Pradesh",
    "Jharkhand",
    "Karnataka",
    "Kerala",
    "Madhya Pradesh",
    "Maharashtra",
    "Manipur",
    "Meghalaya",
    "Mizoram",
    "Nagaland",
    "Odisha",
    "Punjab",
    "Rajasthan",
    "Sikkim",
    "Tamil Nadu",
    "Telangana",
    "Tripura",
    "Uttar Pradesh",
    "Uttarakhand",
    "West Bengal",
    "Andaman and Nicobar Islands",
    "Chandigarh",
    "Dadra and Nagar Haveli and Daman and Diu",
    "Lakshadweep",
    "Delhi",
    "Puducherry",
    "Jammu and Kashmir",
    "Ladakh",
  ];

  const aniTestList = [
    { name: 'Power BI & Data Science', value: 'power_Bi_And_Data_Science' },
    // { name: 'Data Science', value: 'data_Science' },
    { name: 'Data Engineer', value: 'data_Engineer' },
    { name: 'Adobe Analytics Implementation', value: 'adobe_Analytics_Implementation' },
    { name: 'AEP CDP Architect', value: 'aep_Cdp_Architect' },
    { name: 'AEP CJA', value: 'aep_Cja' },
    { name: 'Big Query', value: 'big_Query' },
    { name: 'Gen AI', value: ['gen_AI', 'gen_AI_Theory'] },
  ];

  const handleSelectState = (selectedState) => {
    setFormData((prevState) => ({
      ...prevState,
      state: selectedState,  // Update the formData with the selected state
    }));
    setStateSuggestions([]);  // Clear suggestions once a state is selected
    setShowSuggestions(false);  // Hide the suggestion dropdown
  };

  const handleDateChange = (date, dateString) => {
    setFormData((prevState) => ({
      ...prevState,
      lwd: dateString,
    }));
  };




  const validateForm = () => {
    let isValid = true;
    // if (!formData.lwd){
    //   message.error("Choose your Last Working Day")
    //   isValid= false;
    // }

    if (!formData.firstName) {
      message.error("Enter First Name");
      isValid = false;
    } else if (!/^[A-Za-z]+$/.test(formData.firstName)) {
      message.error(
        "Firstname should be of Alphabets without spaces & special Characters(!@#$%^,..)"
      );
      isValid = false;
    }
    if (!formData.lastName) {
      message.error("Enter Last Name");
      isValid = false;
    } else if (!/^[A-Za-z]+$/.test(formData.lastName)) {
      message.error(
        "Lastname should be of Alphabets without spaces & special Characters(!@#$%^,..)"
      );

      isValid = false;
    }
    if (
      !/^[A-Za-z]+$/.test(formData.currentLocation) &&
      formData.currentLocation
    ) {
      message.error("Current Location should be of Alphabets");

      isValid = false;
    }

    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    if (!formData.email || !emailRegex.test(formData.email)) {
      message.warning("Enter Valid Email");
      isValid = false;
    } else if (formData.email.includes("@enfuse-solutions.com")) {
      message.error("Emails from '@enfuse-solutions.com' are not allowed");
      isValid = false;
    }

    if (!formData.resume) {
      message.warning("Please upload a valid Resume in .doc/.pdf format");
      isValid = false;
    } else if (formData.resume.name) {
      const allowedExtensions = ["doc", "pdf"];
      const fileExtension = formData.resume.name.split(".").pop().toLowerCase();

      if (!allowedExtensions.includes(fileExtension)) {
        message.error("Resume must be in .doc or .pdf format");
        isValid = false;
      }
    }

    if (!formData.contact) {
      message.error("Enter valid contact Number");

      isValid = false;
    } else if (!/^\d{10}$/.test(formData.contact)) {
      message.error("Enter Valid 10 - digit contact Number");
      isValid = false;
    }

    if (!formData.qualification || formData.qualification.length < 2) {
      message.error("Add Custom Qualification");
      isValid = false;
    }

    // if (!formData.selectedCategory) {
    //   message.error("Please Choose Category");
    //   isValid = false;
    // }

    // if (!formData.selectedCategory && formData.source !== "career") {
    //   message.error("Please Choose Category");
    //   isValid = false;
    // }

    const expRegex = /^\d{0,5}(\.\d{0,2})?$/;
    if (
      !expRegex.test(formData.totalExperience) ||
      !expRegex.test(formData.relevantExperience)
    ) {
      if (
        parseInt(formData.relevantExperience) >
        parseInt(formData.totalExperience)
      ) {
        message.error(
          "Relevant Experience should be of numbers only & less than or equal to Total Experience"
        );
        isValid = false;
      }
    }

    return isValid;
  };

  useEffect(() => {
    fetchJobPositions();
  }, []);

  useEffect(() => {
    if (formData.selectedCategory === "ANI-Test") {
      setShowModal(true);
    } else {
      setShowModal(false);
    }
  }, [formData.selectedCategory]);


  const fetchJobPositions = async () => {
    try {
      const response = await axios.get(`${URL}/api/viewjobs`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const jobPositions = response.data;

      // Filter jobs with status "REQ Approved"
      const approvedJobs = jobPositions.filter(job => job.status === "REQ Approved");

      setPositions(approvedJobs);
    } catch (error) {
      console.error("Error fetching job positions:", error);
    }
  };


  const handleChange = async (e) => {
    e.preventDefault();

    if (e.target.name === "image" || e.target.name === "resume") {
      const uploadFormData = new FormData();
      uploadFormData.append(e.target.name, e.target.files[0], e.target.files[0].name);

      const uploadEndpoint = e.target.name;
      const response = await fetch(`${URL}/api/upload/` + uploadEndpoint, {
        method: "POST",
        body: uploadFormData,
      });

      if (!response.ok) {
        console.error("Image upload failed with status code", response.status);
      } else {
        console.log("Image uploaded successfully");
      }

      const data = await response.json();
      console.log(data);

      setFormData((prevState) => ({
        ...prevState,
        [e.target.name]: data["uploadedFile"],
      }));
    } else {
      const { name, value } = e.target;

      setFormData((prevState) => ({
        ...prevState,
        [name]: name === "noticePeriod" && value === "other" ? "" : value,
      }));

      if (name === "noticePeriod" && value === "other") {
        const { value: customValue } = await Swal.fire({
          input: "text",
          inputLabel: "Enter custom Notice Period",
          inputPlaceholder: "e.g., 90 days",
          showCancelButton: true,
        });

        if (customValue) {
          setFormData((prevState) => ({
            ...prevState,
            noticePeriod: customValue,
          }));
        }
      }

      // Trigger grammar check for relevant fields
      if (['qualification', 'city', 'district'].includes(name)) {
        debouncedCheckGrammar(name, value);
      }
    }
  };

  const renderSuggestions = (matches) => (
    <ul style={{ color: 'red', margin: '0 0 30px 0', paddingLeft: '20px' }}>
      {matches.map((m, idx) => (
        <li key={idx}>
          <strong>{m.context.text}</strong> ➤{' '}
          {m.replacements.length
            ? `Try: ${m.replacements.map((r) => r.value).join(', ')}`
            : m.message}
        </li>
      ))}
    </ul>
  );

  const sendConfirmationEmail = async (candidateData) => {
    try {
      await fetch(`${URL}/api/user/register`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: candidateData.email,
          fullName: candidateData.fullName,
          username: candidateData.username,
          source: candidateData.source,
          role: candidateData.role,
          mgrName: candidateData.mgrName,
          mgrEmail: candidateData.mgrEmail,
          position: candidateData.position,
          reference: candidateData.reference,
          currentLocation: candidateData.currentLocation,
          lwd: candidateData.lwd,
          selectedCategory: candidateData.selectedCategory,
          // include other details as needed


        }),
      });
    } catch (error) {
      console.error('Error sending confirmation email:', error);
    }
  };

// const sendConfirmationEmail = async (candidateData) => {
//   try {
//     await fetch(`${URL}/api/user/register`, {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//       },
//       body: JSON.stringify({
//         email: candidateData.email,
//         fullName: candidateData.fullName,
//         username: candidateData.username,
//         source: candidateData.source,
//         role: candidateData.role,
//         mgrName: candidateData.mgrName,
//         mgrEmail: candidateData.mgrEmail,
//         position: candidateData.position,
//         reference: candidateData.reference,
//         currentLocation: candidateData.currentLocation,  
//         lwd: candidateData.lwd,
//         selectedCategory: candidateData.selectedCategory,
//         // include other details as needed

         
//       }),
//     });
//   } catch (error) {
//     console.error('Error sending confirmation email:', error);
//   }
// };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const randomNumber = Math.floor(Math.random() * 10000);
    const fullName = formData.firstName + " " + formData.lastName;
    const username = formData.firstName + "." + formData.lastName + randomNumber;
    const password = Math.random().toString(36).slice(-8);
    const createdAt = new Date(); // This will be used as the endDate for HR TAT

    const historyNote = "Initial registration of an Applicant";
    const historyUpdate = {
      status: "CV Sourced",
      updatedBy: auth.fullName || "Applicant",
      updatedAt: new Date(),
      note: historyNote,
    };

    // Prepare tatHistory with HR TAT and OPS TAT details
    const tatHistory = formData.postedAt
      ? [
        {
          tatType: "HR TAT",
          startDate: formData.postedAt,
          jobId: formData.jobId,
          endDate: createdAt,
          tatStatus: "CV Sourced"          // Use createdAt as endDate
        },
        {
          tatType: "OPS TAT",
          startDate: createdAt,
        },
      ]
      : [];

    const formDataWithFullName = {
      ...formData,
      fullName,
      username,
      password,
      confirmPassword: password,
      createdAt,
      mgrName: selectedHrName || "careers",
     mgrEmail: selectedHrEmail || "careers@enfuse-solutions.com",
     
      reference: formData.reference,
      currentLocation: formData.city,
      jobId: formData.jobId,
      history: [historyUpdate],
      position: formData.position || positionId,
      tatHistory,
      source: formData.source
    };

   if (formDataWithFullName.selectedCategory === "") {
  delete formDataWithFullName.selectedCategory;
}

    console.log("Selected HR Name:", selectedHrName);
    console.log("Selected HR Email:", selectedHrEmail);

    const isValid = validateForm();
    if (!isValid) {
      message.error("Something went wrong");
      return;
    }

    try {
      // Show loading spinner
      Swal.fire({
        title: "Submitting...",
        text: "Please wait while your application is being submitted.",
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading(),
      });

      // Submit the main form
      const response = await fetch(`${URL}/api/register/candidate`, {
        method: "POST",
        body: JSON.stringify(formDataWithFullName),
        headers: {
          "Content-Type": "application/json",
        },
      });

      const candidateData = await response.json();

      if (response.status === 201) {
        Swal.close();
        message.success("Applicant saved successfully");
        await Swal.fire({
          title: "Application Submitted",
          text: "Your application has been submitted successfully. HR will get back to you shortly.",
          icon: "success",
          confirmButtonText: "Close",
        });

        await sendConfirmationEmail(candidateData);

        // Close the modal
        closeModal();
      } else if (response.status === 409) {
        Swal.close();
        const errorData = candidateData;
        message.error(errorData.message || "Email or Username already in use");
      } else {
        Swal.close();
        message.error("Registration Failed");
      }
    } catch (error) {
      Swal.close();
      message.error("An error occurred during registration.");
      console.error("Registration error:", error);
    }
  };

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <div className='formContainer' style={{ gap: '4rem' }}>
          <div className='block' >
            <div>
              <label>First Name<span className='require'>*</span></label>
              <input type="text" name="firstName" value={formData.firstName} required onChange={handleChange} placeholder="Enter First name"></input></div>
            <div><label>Email<span className='require'>*</span></label>
              <input type="text" name="email" value={formData.email} required onChange={handleChange} placeholder="Enter valid Mail Id "></input></div>
            <div><label>Total Experience<span className='require'>*</span></label>
              <input type="text" name="totalExperience" value={formData.totalExperience} onChange={handleChange} placeholder="Enter Number of years only "></input></div>
            <div><label>Notice Period<span className='require'>*</span></label>
              <select name="noticePeriod" style={{ width: '100%' }} value={formData.noticePeriod} onChange={handleChange}>
                <option value="">Choose One</option>
                <option value="Immediate">Immediate </option>
                <option value="30days">Less than 30days</option>
                <option value="45days">Less than 45days</option>
                <option value="90days">90days</option>
              </select>
            </div>
            <div>
              <label>City<span className='require'>*</span></label>
              <input
                type="text"
                name="city"
                required={true}
                value={formData.city}
                maxLength={20}
                placeholder="Enter city"
                onChange={handleChange}
              />
              {errors.city.length > 0 && renderSuggestions(errors.city)}
            </div>
            <div>
              <label>State<span className='require'>*</span></label>
              <select
                name="state"
                required={true}
                value={formData.state}  // Bind the select value to formData.state
                onChange={handleChange}  // Handle state change on selection
              >
                <option value="">Select a state</option> {/* Default option */}
                {statesList.map((state, index) => (
                  <option key={index} value={state}>
                    {state}
                  </option>
                ))}
              </select>
            </div>

            <div>
              <label>Resume<span className='require'>*</span></label>
              <input type="file" name="resume" path={formData.resume} required onChange={handleChange} accept=".pdf, .doc" placeholder=".pdf, .doc" ></input>
            </div>
            {auth.email && (
              <div>
                <label>Reference</label>
                <input type="text" name="reference" value={formData.reference} onChange={handleChange} placeholder="Enter Referred By Name"></input>
              </div>
            )}

            <div>
              <label>Last Working Day</label>
              <DatePicker
                name="lwd"
                required
                value={formData.lwd ? moment(formData.lwd) : null}
                onChange={handleDateChange}
                placeholder="Choose Last Working Day"
                style={{ width: '340px', border: '1px solid #00B4D2', padding: '5px 10px 0px 10px', height: '35px' }}
              //  // Apply date restriction
              />
            </div>
          </div>
          <div className='block' style={{ float: 'right' }}>
            <div>
              <label>Last Name<span className='require'>*</span></label>
              <input type="text" name="lastName" value={formData.lastName} required placeholder="Enter Last name" onChange={handleChange}></input>
            </div>
            <div><label>Contact Number<span className='require'>*</span></label>
              <input type="text" name="contact" value={formData.contact} maxLength={10} onChange={handleChange} required placeholder="Enter 10-digit valid mobile No."></input>
            </div>
            <div><label>Relevant Experience<span className='require'>*</span></label>
              <input type="text" name="relevantExperience" value={formData.relevantExperience} onChange={handleChange} placeholder="Enter Number of years only "></input>
            </div>
            <div><label>Qualification<span className='require'>*</span></label>
              <input type="text" name="qualification" value={formData.qualification} onChange={handleChange} placeholder="Highest Qualification"></input>
              {errors.qualification.length > 0 && renderSuggestions(errors.qualification)}
            </div>
            <div>
              <label>District</label>
              <input
                type="text"
                name="district"
                value={formData.district}
                maxLength={20}
                placeholder="Enter district"
                onChange={handleChange}
              />
              {errors.district.length > 0 && renderSuggestions(errors.district)}
            </div>
            <div>
              <label>Position</label>
              <select
                name="position"
                value={formData.position}
                onChange={handlePositionChange}
                style={{ width: '100%' }}
                disabled={Boolean(appliedPosition)}
              >
                <option value="">Choose One</option>
                {positions.map((position) => (
                  <option key={position._id} value={position.position}>
                    {position.position}
                  </option>
                ))}
              </select>
            </div>
            {auth.email && (<div><label>Category(For Screening)<span className='require'>*</span></label>
              <select name="selectedCategory" value={formData.selectedCategory} style={{ width: '100%' }} onChange={handleChange} placeholder="Choose Category" >
                <option value="">Choose One</option>
                <option value="Technical">Technical</option>
                <option value="Non-Technical">Non-Technical</option>
                <option value="ANI-Test">ANI-Test</option>
                <option value="No-Test">No-Test</option>
              </select>
            </div>)}
           <div>
  <label htmlFor="source">
    {auth?.email ? 'Source' : 'How did you hear about us?'}
  </label>

  {auth?.email ? (
    <input
      type="text"
      name="source"
      value={formData.source}
      onChange={handleChange}
      required
      style={{ width: '100%' }}
      placeholder="Enter source"
    />
  ) : (
    <select
      name="source"
      value={formData.source}
      onChange={handleChange}
      required
      style={{ width: '100%' }}
    >
      <option value="">Select an option</option>
      <option value="Company Website">Company Website</option>
      <option value="Job Portal">Job Portal</option>
      <option value="Word of Mouth">Word of Mouth</option>
      <option value="Social Media">Social Media</option>
    </select>
  )}
</div>

            

            {auth.email && (
              <div>
                <HrDropdown onSelect={handleSelectHr} onSelectHr={handleSelectHr} required onChange={(value, option) => handleSelectHr(option.fullName, option.email)} />
              </div>
            )}
          </div>
        </div>
        <div id='btnWrapper'>
          <Button className='btn-apply' style={{ backgroundColor: '#A50707', float: 'end', marginTop: '15px' }} type="submit" onClick={handleSubmit} >Submit Application</Button>
        </div>
      </form>
      <center><p style={{ color: '#A50707' }}>* Fields are required</p></center>
      {
        showModal &&
        <MyAniTestModal formData={formData} setFormData={setFormData} aniTestList={aniTestList} setShowModal={setShowModal} />
      }
    </div>
  )
}

const MyAniTestModal = ({ formData, setFormData, aniTestList, setShowModal }) => {


  const handleCancel = () => {
    console.log('Hii Cancel');

  }



  const handleCheckboxChange = (testValue) => {
    console.log('Hello from checkbox field...');
    console.log('testValue: ', testValue);

    let updatedTests = [...formData.aniTests];

    // If testValue is an array (e.g., ['gen_AI', 'gen_AI_Theory'])
    if (Array.isArray(testValue)) {
      const allSelected = testValue.every(val => updatedTests.includes(val));

      if (allSelected) {
        // Deselect all
        updatedTests = updatedTests.filter(test => !testValue.includes(test));
      } else {
        // Select all (add missing ones)
        testValue.forEach(val => {
          if (!updatedTests.includes(val)) updatedTests.push(val);
        });
      }
    } else {
      const isSelected = updatedTests.includes(testValue);
      updatedTests = isSelected
        ? updatedTests.filter(test => test !== testValue)
        : [...updatedTests, testValue];
    }

    console.log('updatedTests: ', updatedTests);

    setFormData(prevData => ({
      ...prevData,
      aniTests: updatedTests
    }));
  };


  return (
    <>
      <div className="modal-wrapper"></div>
      <div className="modal-container">
        <label>Assign ANI Tests <span style={{ color: 'red' }}>*</span></label>

        <div>
          {aniTestList.map((test, index) => (
            <div key={index} style={{ display: 'flex', marginTop: '8px' }}>
              <input
                type="checkbox"
                value={test.value}
                // checked={formData.aniTests.includes(test.value)}
                checked={
                  Array.isArray(test.value)
                    ? test.value.every(val => formData.aniTests.includes(val))
                    : formData.aniTests.includes(test.value)
                }
                onChange={() => handleCheckboxChange(test.value)}
                style={{ marginLeft: '-150px', marginTop: '4px' }}
              />
              <span style={{ marginLeft: '-150px' }}>{test.name}</span>
            </div>
          ))}
        </div>


        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <button type="button" style={{ padding: '5px', margin: '5px', backgroundColor: 'white', borderRadius: '5px', cursor: 'pointer' }} onClick={() => setShowModal(false)} disabled={formData.aniTests.length === 0}>Select</button>

        </div>
      </div>
    </>
  )
}

export default Registration;